/**
 * Pagination and list display constants
 */

// Domain-specific pagination limits
/** Default limit for matters lists */
export const MATTERS_PAGE_SIZE = 100;

// Preview limits for overview/summary cards
/** Number of contacts to show in overview preview */
export const PREVIEW_CONTACTS_COUNT = 5;

/** Number of inventory items to show in overview preview */
export const PREVIEW_INVENTORY_COUNT = 3;

/** Number of timeline events to show in overview preview */
export const PREVIEW_TIMELINE_COUNT = 5;

/** Number of search results to show in search dropdown */
export const SEARCH_RESULTS_LIMIT = 10;
